// extracted by mini-css-extract-plugin
export default {"slider":"LogoSlider_slider__nz7jc","slideTrack":"LogoSlider_slideTrack__vmEJN","slide":"LogoSlider_slide__cO16w"};